import { useMemo } from 'react';
import { Button, fToCurrency } from '@web/utils';

interface OrderSummaryWIthCheckoutProps {
  orderTotal: number;
  totalPercentes: number;
  taxesByPercentage: { percent: number; value: number }[];
  submitResult: any;
  handleOrderSubmit: () => void;
  className?: string;
  t: any;
  disableCheckoutButton?: boolean;
  hasZeroPricedItem?: boolean;
}

const OrderSummaryWithCheckout = (props: OrderSummaryWIthCheckoutProps) => {
  const {
    taxesByPercentage,
    totalPercentes,
    orderTotal,
    handleOrderSubmit,
    submitResult,
    className = '',
    t,
    disableCheckoutButton,
    hasZeroPricedItem = false,
  } = props;

  const isAdminCheckoutPage = window.location.pathname.includes('customer');

  const totalNet = useMemo(() => {
    return hasZeroPricedItem || orderTotal === 0
      ? '*'
      : fToCurrency(orderTotal);
  }, [hasZeroPricedItem, orderTotal]);

  const totalGross = useMemo(() => {
    return hasZeroPricedItem || orderTotal + totalPercentes === 0
      ? '*'
      : fToCurrency(orderTotal + totalPercentes);
  }, [hasZeroPricedItem, orderTotal + totalPercentes]);

  return (
    <div className={className}>
      <p className="font-bd text-body1 leading-1-0 mb-3-5">
        {t('checkout.summary')}
      </p>
      <div className="flex justify-between p-1-5 border-b-2 border-primary-black ">
        <p className="font-bd text-primary-grey text-body1 leading-1-5">
          {t('checkout.total_net')}
        </p>
        <p className="text-body1 leading-1-5 " role="net-price">
          {totalNet}
        </p>
      </div>
      <div role="tax-rates">
        {hasZeroPricedItem ||
          (totalPercentes > 0 &&
            taxesByPercentage.map((taxRate) => {
              if (taxRate.value > 0) {
                return (
                  <div
                    key={taxRate.value}
                    className="flex justify-between p-1-5 border-b border-primary-border"
                    role="tax-rate"
                  >
                    <p className="font-bd text-primary-grey text-body1 leading-1-5">
                      {taxRate.percent} %
                    </p>
                    <p className="text-body1 leading-1-5 ">
                      {fToCurrency(taxRate.value)}
                    </p>
                  </div>
                );
              }
            }))}
      </div>
      <div className="flex justify-between p-1-5">
        <p className="text-3-0 md:text-2-0 font-bd text-primary-black leading-1-5">
          {t('checkout.total_gross')}
        </p>
        <p
          className="text-3-0 md:text-2-0 leading-1-5 font-bd"
          role="gross-price"
        >
          {fToCurrency(totalGross)}
        </p>
      </div>
      {!isAdminCheckoutPage && (
        <p
          className="text-2-2 md:text-1-2 font-bd mb-5-0 md:my-2-5"
          role="delivery-terms"
        >
          {t('checkout.delivery_terms')}
        </p>
      )}
      {!disableCheckoutButton && (
        <div className="mb-2-5">
          <Button
            disabled={submitResult.fetching}
            onClick={handleOrderSubmit}
            data-testid="checkout-submit-btn"
          >
            {t('checkout.submit_order')}
          </Button>
        </div>
      )}
      {!isAdminCheckoutPage && (
        <div className="text-primary-dark text-2-0 md:text-1-2 flex flex-col gap-1-0">
          <p>{t('checkout.disclaimer')}</p>
          {hasZeroPricedItem && <p>{t('checkout.disclaimer_2')}</p>}
        </div>
      )}
    </div>
  );
};

export default OrderSummaryWithCheckout;
